/* Artemesia 2026 PDP: sticky Add to bag + jump to reviews. No dependencies. */
(function () {
  var atc = document.querySelector('[data-add-to-cart]');
  var bar = document.querySelector('[data-am-sticky]');

  if (bar && atc) {
    var priceEl = document.querySelector('[data-product-price]');
    var out = bar.querySelector('[data-am-sticky-price]');
    var tidy = function (t) { return t.replace(/(\d)\.00(\D*)$/, '$1$2'); };
    var sync = function () { if (priceEl && out) { out.textContent = ' \u00b7 ' + tidy(priceEl.textContent.trim()); } };
    sync();
    if (priceEl && window.MutationObserver) {
      new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    var stickyBtn = bar.querySelector('[data-am-sticky-add]');
    stickyBtn.addEventListener('click', function () { currentAtc().click(); });

    /* Visible on arrival and whenever the main purchase button is offscreen.
       The native form remains the source of variant, price and availability. */
    function currentAtc() { return document.querySelector('[data-add-to-cart]') || atc; }
    var previewObserver = null;
    var previewWrapper = null;
    function refresh() {
      var el = currentAtc();
      var wrapper = document.getElementById('PBarNextFrameWrapper');
      var offset = wrapper ? Math.max(0, Math.min(wrapper.getBoundingClientRect().height, window.innerHeight - wrapper.getBoundingClientRect().top)) : 0;
      bar.style.setProperty('--am-preview-offset', offset + 'px');
      if (wrapper && wrapper !== previewWrapper && window.ResizeObserver) {
        if (previewObserver) { previewObserver.disconnect(); }
        previewWrapper = wrapper;
        previewObserver = new ResizeObserver(refresh);
        previewObserver.observe(wrapper);
      }
      var box = el.getBoundingClientRect();
      var inView = box.top >= 0 && box.bottom <= window.innerHeight - offset;
      var disabled = el.disabled || el.classList.contains('disabled');
      if (stickyBtn.disabled !== disabled) { stickyBtn.disabled = disabled; }
      var label = el.querySelector('[data-add-to-cart-text]');
      var text = disabled && label ? label.textContent.trim() : 'Add to bag';
      var price = priceEl ? ' · ' + tidy(priceEl.textContent.trim()) : '';
      var wanted = text + (disabled ? '' : price);
      if (stickyBtn.textContent !== wanted) { stickyBtn.textContent = wanted; }
      bar.hidden = inView;
    }
    document.addEventListener('change', function () { setTimeout(refresh, 0); }, true);
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    if (window.MutationObserver) {
      new MutationObserver(refresh).observe(atc.closest('form') || document.body, {
        attributes: true, childList: true, characterData: true, subtree: true,
        attributeFilter: ['disabled', 'class']
      });
    }
    [400, 1200, 2500].forEach(function (t) { setTimeout(refresh, t); });
    refresh();
  } else if (bar) {
    bar.parentNode.removeChild(bar);
  }

  /* The swatch app hides every native variant selector but only draws swatches
     for the options it has a set for, which can leave an option (Size) with no
     control at all. Bring back any selector the app did not actually draw.
     Re-checked a few times because the app renders asynchronously. */
  function restoreUndrawnOptions() {
    var root = document.querySelector('.swatches');
    if (!root) { return; }
    var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      var name = w.getAttribute('data-select-label');
      var group = null;
      try { group = root.querySelector('[option-name="' + name + '"]'); } catch (e) { group = null; }
      var drawn = group && group.querySelectorAll('.swatch-view-item').length > 0;
      if (!drawn) { w.setAttribute('data-am-unhidden', ''); }
      else { w.removeAttribute('data-am-unhidden'); }
    }
  }
  /* The app also marks nothing as selected until the shopper clicks, so on load
     no colour reads as chosen. Mirror the checked native radio onto its swatch. */
  function markSelectedSwatches() {
    var root = document.querySelector('.swatches');
    if (!root) { return; }
    var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
    for (var i = 0; i < wrappers.length; i++) {
      var name = wrappers[i].getAttribute('data-select-label');
      var chosen = wrappers[i].querySelector('input:checked');
      var group = null;
      try { group = root.querySelector('[option-name="' + name + '"]'); } catch (e) { group = null; }
      if (!chosen || !group) { continue; }
      var items = group.querySelectorAll('.swatch-view-item');
      for (var j = 0; j < items.length; j++) {
        items[j].setAttribute('aria-checked', items[j].getAttribute('orig-value') === chosen.value ? 'true' : 'false');
        items[j].setAttribute('tabindex', items[j].getAttribute('orig-value') === chosen.value ? '0' : '-1');
      }
    }
  }

  /* --- stock line ------------------------------------------------------------
     "1 of 7 dresses": the chosen size's remaining stock, out of that colour's
     total across sizes. Quantities come from the JSON island the section emits,
     because Shopify no longer exposes inventory_quantity in the storefront
     product JSON. Placement is done here rather than in Liquid: the size picker
     is drawn by the swatch app, asynchronously, so there is no stable spot to
     render into. */
  var stockEl = document.querySelector('[data-am-stock]');
  var stockData = null;
  try {
    var island = document.querySelector('[data-am-inventory]');
    if (island) { stockData = JSON.parse(island.textContent); }
  } catch (err) { stockData = null; }

  function wrapperFor(name) {
    var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
    for (var i = 0; i < wrappers.length; i++) {
      var label = (wrappers[i].getAttribute('data-select-label') || '').toLowerCase();
      if (label === name) { return wrappers[i]; }
    }
    return null;
  }

  function chosenValue(name) {
    var w = wrapperFor(name);
    if (!w) { return null; }
    var checked = w.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function appGroup(name) {
    var root = document.querySelector('.swatches');
    if (!root) { return null; }
    var group = null;
    try { group = root.querySelector('[option-name="' + name + '"]'); } catch (e) { return null; }
    if (!group || group.querySelectorAll('.swatch-view-item').length === 0) { return null; }
    if (group.offsetParent === null) { return null; }
    return group.closest('.swatch-wrapper') || group;
  }

  function visibleWrapper(name) {
    var w = wrapperFor(name);
    return (w && w.offsetParent !== null) ? w : null;
  }

  /* Size first, in whichever form is on screen: the app draws its Size swatches
     lazily (only after a colour is touched), and until then the native selector
     is what the shopper sees. Checking the app's colour group before the native
     size control would drop the line above the swatches instead of between the
     two, which is not where the board puts it. Colour and the add-to-cart button
     are last-resort anchors for single-option products. */
  function stockAnchor() {
    return appGroup('Size')
        || visibleWrapper('size')
        || appGroup('Color')
        || appGroup('Colour')
        || visibleWrapper('color')
        || visibleWrapper('colour')
        || atc
        || null;
  }

  function qtyOf(v) {
    if (v === null || v === undefined) { return null; }
    return v < 0 ? 0 : v;
  }

  function optionIndex(name) {
    var names = (stockData && stockData.names) || [];
    for (var i = 0; i < names.length; i++) {
      if (names[i] === name) { return i; }
    }
    return -1;
  }

  function updateStock() {
    if (!stockEl || !stockData || !stockData.variants || !stockData.variants.length) { return; }

    var colourIdx = optionIndex('color');
    if (colourIdx < 0) { colourIdx = optionIndex('colour'); }
    var sizeIdx = optionIndex('size');

    var colour = colourIdx > -1 ? (chosenValue('color') || chosenValue('colour')) : null;
    var size = sizeIdx > -1 ? chosenValue('size') : null;

    var total = 0;
    var selected = null;

    for (var i = 0; i < stockData.variants.length; i++) {
      var v = stockData.variants[i];
      /* null means the variant is not inventory-tracked, so there is no honest
         number to print for this product at all. */
      if (v.q === null || v.q === undefined) { stockEl.hidden = true; return; }
      var q = v.q < 0 ? 0 : v.q;

      if (colourIdx > -1 && colour !== null && v.o[colourIdx] !== colour) { continue; }
      total += q;
      if (sizeIdx > -1 && size !== null && v.o[sizeIdx] === size) { selected = q; }
    }

    var text = '';
    if (selected !== null) {
      if (selected > 0) { text = selected + ' available in this colour and size'; }
    } else if (total > 0) {
      text = total + ' available' + (colour !== null ? ' in this colour' : '');
    }

    if (!text) { stockEl.hidden = true; return; }

    var target = stockAnchor();
    if (!target || !target.parentNode) { stockEl.hidden = true; return; }
    if (stockEl.nextElementSibling !== target) {
      target.parentNode.insertBefore(stockEl, target);
    }
    if (stockEl.textContent !== text) { stockEl.textContent = text; }
    stockEl.hidden = false;
  }

  /* --- buy state -------------------------------------------------------------
     Board tmpl-1 loads with Deep Navy already chosen and ADD TO BAG live. The
     swatch app is configured with preselect_variant off, so on load it disables
     the add-to-cart and rewrites its label to "Select a Color" -- even though
     Shopify HAS preselected a variant and both native radios are checked
     (verified on Collar Dress: hidden input holds 43199831867459, "Deep Navy /
     XS", available). The page therefore could not be bought from until the
     shopper clicked a swatch that already looked selected.

     Fixed here rather than by flipping the app's own preselect setting, because
     that setting lives in config/settings_data.json -- 28KB of auto-generated
     config the theme editor rewrites. The app stores the wording it replaced on
     the element itself as original-text, so the real label is recovered rather
     than hardcoded.

     Only ever re-enabled for a variant the product JSON reports as available, so
     a sold-out combination keeps the theme's own disabled state and wording. */
  var productData = null;
  try {
    var pjson = document.querySelector('[data-product-json]');
    if (pjson) { productData = JSON.parse(pjson.textContent); }
  } catch (err2) { productData = null; }

  function selectedVariant() {
    if (!productData || !productData.variants) { return null; }
    var hidden = document.querySelector('[name="id"]');
    if (!hidden || !hidden.value) { return null; }
    var id = String(hidden.value);
    for (var i = 0; i < productData.variants.length; i++) {
      if (String(productData.variants[i].id) === id) { return productData.variants[i]; }
    }
    return null;
  }

  function everyOptionChosen() {
    var wrappers = document.querySelectorAll('.selector-wrapper[data-select-label]');
    if (!wrappers.length) { return false; }
    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].querySelector('input:checked')) { return false; }
    }
    return true;
  }

  function restoreBuyState() {
    var btn = document.querySelector('[data-add-to-cart]');
    if (!btn) { return; }
    var original = btn.getAttribute('original-text');
    if (!original) { return; }  /* the app has not replaced anything; leave it */
    var variant = selectedVariant();
    if (!variant || !variant.available || !everyOptionChosen()) { return; }
    if (btn.disabled) { btn.disabled = false; }
    if (btn.hasAttribute('disabled')) { btn.removeAttribute('disabled'); }
    var label = btn.querySelector('[data-add-to-cart-text]');
    /* Guarded so the body observer below settles after one pass instead of
       ping-ponging with the app. */
    if (label && label.textContent.trim() !== original) { label.textContent = original; }
  }

  function syncOptionUi() { restoreUndrawnOptions(); markSelectedSwatches(); restoreBuyState(); updateStock(); }

  syncOptionUi();
  [400, 1200, 2500].forEach(function (t) { setTimeout(syncOptionUi, t); });

  /* The app draws its Size swatches lazily — only once a colour is touched — so a
     one-shot check would leave two size pickers on screen. It also renders
     .swatches after this script parses, so an observer rooted there would never
     attach; watch the body instead, throttled with a short timer. (Not
     requestAnimationFrame — that never fires while the tab is hidden, which
     would leave the two pickers on screen until the tab was looked at.) Only
     elements outside .swatches are mutated here, so this cannot loop. */
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      setTimeout(function () { queued = false; syncOptionUi(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  var jump = document.querySelector('[data-am-scroll-reviews]');
  if (jump) {
    jump.addEventListener('click', function (ev) {
      var w = document.querySelector('.jdgm-rev-widg, .jdgm-widget, #shopify-product-reviews');
      if (w) { ev.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }
})();

/* Keep native Slick thumbnails and variant-image navigation; add row controls. */
(function () {
  document.querySelectorAll('[data-product-thumbs]').forEach(function (rail) {
    function setup() {
      var list = rail.querySelector('.slick-dots');
      if (!list || !list.children.length) { return; }
      if (!rail.querySelector('.am-thumbs-nav')) {
        ['previous', 'next'].forEach(function (direction) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'am-thumbs-nav';
          button.setAttribute('aria-label', direction === 'next' ? 'Next product photo' : 'Previous product photo');
          var path = direction === 'next' ? 'M33.634 22.502l-.412.392L10.732 44 10 43.258l22.488-21.106L10 .742 10.732 0 34 22.152z' : 'M10.366 22.502l.412.392L33.268 44l.732-.742-22.488-21.106L34 .742 33.268 0 10 22.152z';
          button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 44 44"><path d="' + path + '"/></svg>';
          button.addEventListener('click', function () {
            var dots = Array.from(rail.querySelectorAll('.slick-dots li'));
            var current = dots.findIndex(function (dot) { return dot.classList.contains('slick-active'); });
            var target = (current + (direction === 'next' ? 1 : -1) + dots.length) % dots.length;
            var link = dots[target].querySelector('a,button');
            if (link) { link.click(); }
          });
          if (direction === 'previous') { rail.insertBefore(button, list); }
          else { rail.appendChild(button); }
        });
      }
      var controls = rail.querySelectorAll('.am-thumbs-nav');
      if (controls.length === 2) {
        if (list.previousElementSibling !== controls[0]) { rail.insertBefore(controls[0], list); }
        if (list.nextElementSibling !== controls[1]) { rail.appendChild(controls[1]); }
      }
      var active = list.querySelector('.slick-active');
      if (active) {
        var item = active.getBoundingClientRect();
        var bounds = list.getBoundingClientRect();
        if (item.left < bounds.left || item.right > bounds.right) {
          list.scrollTo({ left:list.scrollLeft + item.left - bounds.left, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }
    }
    new MutationObserver(setup).observe(rail, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
    setup();
  });
})();
